"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kpa2inhg = exports.kpa2hpa = exports.inhg2kpa = exports.inhg2hpa = exports.hpa2kpa = exports.hpa2inhg = void 0;
var rounding_1 = require("./rounding");
// hPa -> inHg (@0°C)
var hpa2inhg = function (val, decimals) { return rounding_1.default(val * 0.029528744, decimals || 3); };
exports.hpa2inhg = hpa2inhg;
// hPa -> kPa
var hpa2kpa = function (val, decimals) { return rounding_1.default(val / 10, decimals || 2); };
exports.hpa2kpa = hpa2kpa;
// inHg -> hPa (@0°C)
var inhg2hpa = function (val, decimals) { return rounding_1.default(val / 0.029528744, decimals || 1); };
exports.inhg2hpa = inhg2hpa;
// inHg -> kpa
var inhg2kpa = function (val, decimals) { return exports.hpa2kpa(exports.inhg2hpa(val, decimals), decimals); };
exports.inhg2kpa = inhg2kpa;
// kPa -> hPa
var kpa2hpa = function (val, decimals) { return rounding_1.default(val * 10, decimals || 1); };
exports.kpa2hpa = kpa2hpa;
// kpa -> inHg
var kpa2inhg = function (val, decimals) { return exports.hpa2inhg(exports.kpa2hpa(val, decimals), decimals); };
exports.kpa2inhg = kpa2inhg;
